import { render } from "./RejectedRequests.vue?vue&type=template&id=3943c588"
import script from "./RejectedRequests.vue?vue&type=script&lang=js"
export * from "./RejectedRequests.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__